import { useManagedIntegrationList } from '@frontend/api';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useFeatureFlagValue } from 'store/session/hooks';

import { isDefaultIntegration } from '../managedIntegrations/utils';

export const useIsBelowMaxManagedIntegrations = () => {
  const { data: managedIntegrations } = useManagedIntegrationList();
  const nonDefaultIntegrations = managedIntegrations?.filter(
    (integration) => !isDefaultIntegration(integration),
  );
  const maxManagedIntegrations = useFeatureFlagValue(
    featureFlagKeys.maxManagedIntegrations,
  );
  return (nonDefaultIntegrations ?? []).length < maxManagedIntegrations;
};
